var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgInstagram(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 64 64",
    style: {
      enableBackground: "new 0 0 64 64"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "FB"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "ig"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M50,63H14C6.8,63,1,57.2,1,50V14C1,6.8,6.8,1,14,1h36c7.2,0,13,5.8,13,13v36C63,57.2,57.2,63,50,63z M14,3 C7.9,3,3,7.9,3,14v36c0,6.1,4.9,11,11,11h36c6.1,0,11-4.9,11-11V14c0-6.1-4.9-11-11-11H14z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M32,48c-8.8,0-16-7.2-16-16s7.2-16,16-16s16,7.2,16,16S40.8,48,32,48z M32,18c-7.7,0-14,6.3-14,14s6.3,14,14,14 s14-6.3,14-14S39.7,18,32,18z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M50,17c-1.7,0-3-1.3-3-3s1.3-3,3-3s3,1.3,3,3S51.7,17,50,17z M50,13c-0.6,0-1,0.4-1,1s0.4,1,1,1s1-0.4,1-1S50.6,13,50,13z "
  })))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "yt"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "twitter"
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "snapchat"
  })), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "WA"
  })), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    id: "Pinterrest"
  })), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    id: "LinkedIn"
  })), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    id: "Messenger"
  })), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    id: "Tiktok"
  })), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    id: "VK"
  })), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    id: "Thumblr"
  })), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    id: "OK.ru"
  })), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    id: "Weibo"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagram);
export default __webpack_public_path__ + "static/media/instagram.d216725a.svg";
export { ForwardRef as ReactComponent };